









// ICONS: https://github.com/activemerchant/payment_icons/tree/master/app/assets/images/payment_icons
import Vue from 'vue';

export default Vue.extend({
  name: 'Payments',
   props: {
    paymentdata: {
      type: Array,
      required: true,
    }
  },
  methods: {
    capitatalize(string: string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
});
